// extracted by mini-css-extract-plugin
export var cardIcon = "_49-4";
export var checkboxCard = "_49-0";
export var checkboxCardSelected = "_49-1";
export var disabled = "_49-2";
export var outerBorder = "_49-3";
export var spacerMedium = "_49-7";
export var spacerSmall = "_49-6";
export var spacerXsmall = "_49-5";